import { useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import { useMsal } from "@azure/msal-react";
import { baseUrl } from "../../Constants.js";

import "./Feedback.css";
import { Alert } from "@mui/material";

const modalStyling = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  content: {
    width: "35%",
    margin: "auto",
    padding: "30px",
    height: "300px",
  },
};

const styles = {
  disabledButton: {
    backgroundColor: "gray",
    color: "white",
    cursor: "not-allowed",
    margin: 10,
    border: "none",
    textAlign: "center",
    alignItems: "center",
  },
  enabledButton: {
    backgroundColor: "#7f9ff7",
    color: "white",
    cursor: "pointer",
    margin: 10,
    border: "none",
    textAlign: "center",
    alignItems: "center",
  },
};

export default function Feedback() {
  const [open, setOpen] = useState(false);
  const [feedbackRes, setFeedbackRes] = useState("");
  const [toggle, setToggle] = useState(true);
  const [comment, setComment] = useState("");
  const [taInlnStyle, setTaInlnStyle] = useState({ height: "15px" });
  const [rating, setRating] = useState([]);
  const [feedbackErr, setFeedbackErr] = useState(false);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const handleOpen = () => {
    setOpen(true);
    setToggle(true);
    setRating([]);
  };

  const handleClose = () => {
    setOpen(false);
    setToggle(false);
  };

  const handleComment = (commentVal) => {
    if (commentVal.length > 46 && commentVal.length < 92) {
      setTaInlnStyle({ height: "45px" });
    } else if (commentVal.length > 92) {
      setTaInlnStyle({ height: "70px" });
    } else if (commentVal.length < 46) {
      setTaInlnStyle({ height: "21px" });
    }
    setComment(commentVal);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";
    if (process.env.NODE_ENV === "development" || isLocalhost) {
      alert("Not allowed to submit feedback from localhost.");
      return;
    } else {
      setToggle(false);
      axios
        .post(
          `${baseUrl}/feedback`,

          {
            enterprise_id: activeAccount.idTokenClaims.enterpriseID,
            rating: rating.length,
            comment: comment,
          },
          {
            headers: {
              Authorization: localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          setFeedbackRes(response.data.message);
        })
        .catch((error) => {
          setFeedbackErr(error.response.data.message);
        });
      setComment("");
      setRating([]);
    }
  };

  const isSubmitDisabled = rating.length === 0 || comment.length === 0;

  const body = (
    <div className="home-page-feedback">
      {toggle && (
        <div id="feedback_form">
          <form onSubmit={handleSubmit}>
            <div className="feedback_label">Send Feedback</div>
            <div className="feedback">
              <span id="thankYou-close" onClick={handleClose}></span>
              <h6 className="question">
                Tell us your experience with the L&TT Portal!
              </h6>
              <div className="feedback-rating">
                <img
                  src={
                    rating.includes(1)
                      ? process.env.PUBLIC_URL +
                        "/images/feedback/star_active.svg"
                      : process.env.PUBLIC_URL +
                        "/images/feedback/star_inactive.svg"
                  }
                  alt="rating"
                  onClick={() => setRating([1])}
                />
                <img
                  src={
                    rating.includes(2)
                      ? process.env.PUBLIC_URL +
                        "/images/feedback/star_active.svg"
                      : process.env.PUBLIC_URL +
                        "/images/feedback/star_inactive.svg"
                  }
                  alt="rating"
                  onClick={() => setRating([1, 2])}
                />
                <img
                  src={
                    rating.includes(3)
                      ? process.env.PUBLIC_URL +
                        "/images/feedback/star_active.svg"
                      : process.env.PUBLIC_URL +
                        "/images/feedback/star_inactive.svg"
                  }
                  alt="rating"
                  onClick={() => setRating([1, 2, 3])}
                />
                <img
                  src={
                    rating.includes(4)
                      ? process.env.PUBLIC_URL +
                        "/images/feedback/star_active.svg"
                      : process.env.PUBLIC_URL +
                        "/images/feedback/star_inactive.svg"
                  }
                  alt="rating"
                  onClick={() => setRating([1, 2, 3, 4])}
                />
                <img
                  src={
                    rating.includes(5)
                      ? process.env.PUBLIC_URL +
                        "/images/feedback/star_active.svg"
                      : process.env.PUBLIC_URL +
                        "/images/feedback/star_inactive.svg"
                  }
                  alt="rating"
                  onClick={() => setRating([1, 2, 3, 4, 5])}
                />
                <p id="star-text" tabindex="0">
                  {rating.length}/5
                </p>
              </div>
              <textarea
                onChange={(event) => {
                  handleComment(event.target.value);
                }}
                id="feedback-input"
                type="text"
                rows="2"
                placeholder="Please provide suggestions or feedback here"
                style={taInlnStyle}
              ></textarea>
              <div className="submit">
                <button
                  type="submit"
                  style={
                    isSubmitDisabled
                      ? styles.disabledButton
                      : styles.enabledButton
                  }
                  disabled={isSubmitDisabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {!toggle && !feedbackErr && (
        <div id="success_form">
          <span id="thankYou-close" onClick={handleClose}></span>
          <h2 className="feedback-success">Thank you!</h2>
          <p className="feedback-success-msg">{feedbackRes}</p>
        </div>
      )}
      {!toggle && feedbackErr && (
        <div style={{ marginTop: "30px" }}>
          <span id="thankYou-close" onClick={handleClose}></span>
          <Alert severity="error">{feedbackErr}</Alert>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className="rightsidebar-wrap">
        <div className="rightsidebar-row">
          <div className="sideimg-box">
            <div className="feedback-extra-box" onClick={handleOpen} tabIndex={0}>
              <img
                src="images/Sidebar/new-icons/rightside-feedback.png"
                alt="logo"
                className="white-icon rightside-feedback-icon"
              />
              <img
                src="images/Sidebar/new-icons/rightside-feedback-hover.png"
                alt="logo"
                className="grey-icon rightside-feedback-icon-hover"
              />
              <p className="feedback-word">Feedback</p>
            </div>
          </div>
        </div>

        <Modal isOpen={open} style={modalStyling}>
          {body}
        </Modal>
      </div>
    </>
  );
}
